module.exports = __webpack_public_path__ + "img/ver-by-visa.9fb5d5ea.jpg";